import Vue from 'vue'
import VueRouter, {Route, RouteConfig} from 'vue-router'
import pages from './pages'
import store from '@/store'

import {isAuthenticated} from '@/helpers';


Vue.use(VueRouter);

const routes: Array<RouteConfig> = pages;

const router = new VueRouter({
    mode: 'history',
    routes
});

let currentIndex: number;

function setCurrentRouteIndex(to: Route): void {
    pages.forEach((item, index) => {
        if (item.name === to.name) {
            currentIndex = index;
            store.commit('navigation/SET_CURRENT_INDEX', index)
        }
    });
}

function backwardArrow() {
    if (!store.getters['navigation/getInitial']) return;
    if (currentIndex !== pages.length - 1) {
        store.commit('navigation/BACKWARD_ARROW_STATE', currentIndex)
    }
}

function forwardArrow() {
    if (!store.getters['navigation/getInitial']) return;
    if (currentIndex !== 0) store.commit('navigation/FORWARD_ARROW_STATE', currentIndex - 1)
}

function setTransition(to: Route, from: Route) {

    let toDepth = 0;
    let fromDepth = 0;

    pages.forEach((item, index) => {
        if (item.name === to.name) {
            toDepth = index;
        }
        if (item.name === from.name) {
            fromDepth = index;
        }
    });

    const transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left';

    store.commit('root/SET_TRANSITION', transitionName);
}

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.auth)) {
        if (!isAuthenticated()) {
            store.commit('navigation/SET_PREVIOUS_ROUTE', from.fullPath);
            store.commit('navigation/SET_TARGET_ROUTE', to.fullPath);
            store.commit('modal/SET_AUTH_MODAL_VISIBILITY_TRUE')
        } else {
            next();
        }
    } else {
        next()
    }
})

router.afterEach((to, from) => {
    setCurrentRouteIndex(to);
    backwardArrow();
    forwardArrow();
    setTransition(to, from);
})

export default router
